import { personSystemAlias } from '../../utils/personnel';

export const FIXED_PROJECT_OPTIONS = ['DEPOSITO', 'ADMINISTRACION', 'LOGISTICA', 'MANTENIMIENTO'];
export const MARK_STATUSES = ['LIBRE', 'LICENCIA', 'SUSPENDIDO', 'LIC. MEDICA', 'AUSENTE', 'VACIO'];
export const OPERATION_BANDS = ['Hasta 4 horas', '4 a 8 horas', '8 a 12 horas'];
export const OPERATION_TARIFF_TYPES = ['corporativo', 'social'];
export const OPERATION_TARIFF_MATRIX = {
  corporativo: {
    C1: [
      { band: '0 a 3 horas', from: 0, to: 3, value: 1000 },
      { band: '3 a 6 horas', from: 3, to: 6, value: 1800 },
      { band: '6 a 9 horas', from: 6, to: 9, value: 2400 },
      { band: '9 a 12 horas', from: 9, to: 12, value: 3000 },
      { band: '12 a 14 horas', from: 12, to: 14, value: 4200 },
    ],
    C2: [
      { band: '0 a 3 horas', from: 0, to: 3, value: 1500 },
      { band: '3 a 6 horas', from: 3, to: 6, value: 2400 },
      { band: '6 a 9 horas', from: 6, to: 9, value: 3200 },
      { band: '9 a 12 horas', from: 9, to: 12, value: 4000 },
      { band: '12 a 14 horas', from: 12, to: 14, value: 5600 },
    ],
    C3: [
      { band: '0 a 3 horas', from: 0, to: 3, value: 2000 },
      { band: '3 a 6 horas', from: 3, to: 6, value: 3000 },
      { band: '6 a 9 horas', from: 6, to: 9, value: 4000 },
      { band: '9 a 12 horas', from: 9, to: 12, value: 5000 },
      { band: '12 a 14 horas', from: 12, to: 14, value: 6500 },
    ],
    C4: [
      { band: '0 a 3 horas', from: 0, to: 3, value: 2500 },
      { band: '3 a 6 horas', from: 3, to: 6, value: 4000 },
      { band: '6 a 9 horas', from: 6, to: 9, value: 5000 },
      { band: '9 a 12 horas', from: 9, to: 12, value: 6000 },
      { band: '12 a 14 horas', from: 12, to: 14, value: 8000 },
    ],
  },
  social: {
    S1: [
      { band: 'Hasta 6 horas', from: 0, to: 6, value: 2500 },
      { band: '6 a 8 horas', from: 6, to: 8, value: 2500 },
      { band: '8 a 10 horas', from: 8, to: 10, value: 3000 },
      { band: '10 a 12 horas', from: 10, to: 12, value: 3000 },
    ],
    S2: [
      { band: 'Hasta 6 horas', from: 0, to: 6, value: 3200 },
      { band: '6 a 8 horas', from: 6, to: 8, value: 3200 },
      { band: '8 a 10 horas', from: 8, to: 10, value: 4000 },
      { band: '10 a 12 horas', from: 10, to: 12, value: 4800 },
    ],
    S3: [
      { band: 'Hasta 6 horas', from: 0, to: 6, value: 4000 },
      { band: '6 a 8 horas', from: 6, to: 8, value: 4000 },
      { band: '8 a 10 horas', from: 8, to: 10, value: 5000 },
      { band: '10 a 12 horas', from: 10, to: 12, value: 5000 },
    ],
    S4: [
      { band: 'Hasta 6 horas', from: 0, to: 6, value: 6000 },
      { band: '6 a 8 horas', from: 6, to: 8, value: 6000 },
      { band: '8 a 10 horas', from: 8, to: 10, value: 8000 },
      { band: '10 a 12 horas', from: 10, to: 12, value: 8000 },
    ],
  },
};

export function pad(value) {
  return String(value).padStart(2, '0');
}

export function currentIsoDate() {
  const date = new Date();
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function parseIsoDate(value) {
  const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return null;
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}

export function addIsoDays(value, amount) {
  const date = parseIsoDate(value) || new Date();
  date.setDate(date.getDate() + amount);
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function monthKey(date = new Date()) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}`;
}

export function addMonths(value, amount) {
  const [year, month] = String(value || monthKey()).split('-').map(Number);
  return monthKey(new Date(year, (month || 1) - 1 + amount, 1));
}

export function monthRange(value) {
  const [year, month] = String(value || monthKey()).split('-').map(Number);
  const first = new Date(year, (month || 1) - 1, 1);
  const last = new Date(year, month || 1, 0);
  const format = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  return { from: format(first), to: format(last), first };
}

export function dateKey(value) {
  return String(value || '').slice(0, 10);
}

export function parseDbDateTime(value) {
  const date = new Date(String(value || '').replace(' ', 'T'));
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDbDateTime(date = new Date()) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

export function formatDisplayDate(value = new Date(), options = {}) {
  const date = typeof value === 'string' ? (parseIsoDate(value) || parseDbDateTime(value)) : value;
  if (!date) return 'Fecha no disponible';
  return date.toLocaleDateString('es-UY', {
    weekday: options.weekday || 'long',
    day: '2-digit',
    month: options.month || '2-digit',
    year: options.year || 'numeric',
  });
}

export function formatDisplayTime(value = new Date()) {
  const date = typeof value === 'string' ? parseDbDateTime(value) : value;
  if (!date) return '--:--';
  return date.toLocaleTimeString('es-UY', {
    hour: '2-digit', minute: '2-digit', hour12: false, hourCycle: 'h23',
  });
}

export function formatMonthLabel(value) {
  const { first } = monthRange(value);
  const label = first.toLocaleDateString('es-UY', { month: 'long', year: 'numeric' });
  return label.charAt(0).toUpperCase() + label.slice(1);
}

export function normalizeStatus(value) {
  return String(value || '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, ' ');
}

export function normalizeSearchText(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

export function normalizeProjectOption(value) {
  return String(value || '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, ' ');
}

export function normalizeTime(value) {
  if (!value) return '';
  const cleanValue = String(value).trim().replace('.', ':');
  const [rawHour, rawMinute = '00'] = cleanValue.split(':');
  const hour = Number(rawHour);
  const minute = Number(rawMinute);
  if (!Number.isFinite(hour) || !Number.isFinite(minute)) return '';
  if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return '';
  return `${pad(hour)}:${pad(minute)}`;
}

export function compactTime(value) {
  const time = normalizeTime(value);
  if (!time) return '';
  const [hour, minute] = time.split(':');
  return minute === '00' ? String(Number(hour)) : `${Number(hour)}:${minute}`;
}

export function projectOptionsForTurns(turns = []) {
  const values = new Set(FIXED_PROJECT_OPTIONS);
  turns.forEach((turn) => {
    const status = normalizeStatus(turn.estado);
    const activity = normalizeProjectOption(turn.actividad_ubicacion);
    if (!activity || MARK_STATUSES.includes(status)) return;
    values.add(activity);
  });
  return [...values].sort((left, right) => {
    const leftFixed = FIXED_PROJECT_OPTIONS.includes(left);
    const rightFixed = FIXED_PROJECT_OPTIONS.includes(right);
    if (leftFixed && rightFixed) return FIXED_PROJECT_OPTIONS.indexOf(left) - FIXED_PROJECT_OPTIONS.indexOf(right);
    if (leftFixed) return -1;
    if (rightFixed) return 1;
    return left.localeCompare(right, 'es');
  });
}

export function minutesFromTime(value) {
  const match = String(value || '').match(/^(\d{1,2})(?::(\d{2}))?$/);
  if (!match) return null;
  const hours = Number(match[1]);
  const minutes = Number(match[2] || 0);
  if (hours > 23 || minutes > 59) return null;
  return hours * 60 + minutes;
}

export function shiftHours(start, end) {
  const startMinutes = minutesFromTime(start);
  const endMinutes = minutesFromTime(end);
  if (startMinutes === null || endMinutes === null) return 0;
  const diff = endMinutes >= startMinutes ? endMinutes - startMinutes : endMinutes + 24 * 60 - startMinutes;
  return Math.round((diff / 60) * 100) / 100;
}

export function pairMarksByStartDay(sourceMarks = []) {
  const sorted = sourceMarks
    .slice()
    .sort((a, b) => String(a.fecha_hora).localeCompare(String(b.fecha_hora)));
  const pairs = [];
  let openEntry = null;
  sorted.forEach((mark) => {
    const type = normalizeStatus(mark.tipo);
    if (type === 'ENTRADA') {
      if (openEntry) pairs.push({ dayKey: dateKey(openEntry.fecha_hora), entry: openEntry, exit: null });
      openEntry = mark;
      return;
    }
    if (type === 'SALIDA') {
      if (openEntry) {
        pairs.push({ dayKey: dateKey(openEntry.fecha_hora), entry: openEntry, exit: mark });
        openEntry = null;
        return;
      }
      pairs.push({ dayKey: dateKey(mark.fecha_hora), entry: null, exit: mark });
    }
  });
  if (openEntry) pairs.push({ dayKey: dateKey(openEntry.fecha_hora), entry: openEntry, exit: null });
  return pairs;
}

export function pairTotalHours(pair) {
  const entryDate = pair?.entry ? parseDbDateTime(pair.entry.fecha_hora) : null;
  const exitDate = pair?.exit ? parseDbDateTime(pair.exit.fecha_hora) : null;
  if (!entryDate || !exitDate) return null;
  const diff = (exitDate.getTime() - entryDate.getTime()) / (1000 * 60 * 60);
  return diff >= 0 ? Math.round(diff * 100) / 100 : null;
}

export function formatHours(value) {
  const number = Number(value || 0);
  if (Math.abs(number) % 1 === 0) return String(number);
  return number.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
}

export function formatSignedHours(value) {
  const number = Number(value || 0);
  return `${number > 0 ? '+' : ''}${formatHours(number)} h`;
}

export function formatMoney(value) {
  return new Intl.NumberFormat('es-UY', {
    style: 'currency',
    currency: 'UYU',
    maximumFractionDigits: 0,
  }).format(Number(value || 0));
}

export function activeEntryFromMarks(marks = []) {
  let openEntry = null;
  marks
    .slice()
    .sort((a, b) => String(a.fecha_hora).localeCompare(String(b.fecha_hora)))
    .forEach((mark) => {
      const type = normalizeStatus(mark.tipo);
      if (type === 'ENTRADA') openEntry = parseDbDateTime(mark.fecha_hora);
      if (type === 'SALIDA') openEntry = null;
    });
  return openEntry;
}

export function operationTariffValueForBand(tariff, band) {
  if (!tariff) return 0;
  const matrixBand = operationBandsForTariff(tariff).find((item) => item.band === band);
  if (matrixBand) return Number(matrixBand.value || 0);
  const keys = {
    'Hasta 4 horas': ['valor_hasta_4', 'hasta_4hs'],
    '4 a 8 horas': ['valor_4_a_8', 'de_4_a_8hs'],
    '8 a 12 horas': ['valor_8_a_12', 'de_8_a_12hs'],
  }[band] || [];
  const value = keys.map((key) => tariff[key]).find((item) => item !== undefined && item !== null && item !== '');
  return Number(value || tariff.valor || 0);
}

export function normalizeOperationTariffType(value) {
  const normalized = normalizeSearchText(value);
  return OPERATION_TARIFF_TYPES.find((type) => normalizeSearchText(type) === normalized) || '';
}

export function normalizeOperationTariffCategory(value) {
  return String(value || '').trim().toUpperCase();
}

export function operationCategoriesForType(type) {
  const normalizedType = normalizeOperationTariffType(type);
  return normalizedType ? Object.keys(OPERATION_TARIFF_MATRIX[normalizedType] || {}) : [];
}

export function operationBandsForTariff(tariff) {
  const type = normalizeOperationTariffType(tariff?.tipo);
  const category = normalizeOperationTariffCategory(tariff?.categoria);
  const template = OPERATION_TARIFF_MATRIX[type]?.[category] || [];
  const storedBands = normalizeOperationTariffBands(tariff?.bands, template);
  if (storedBands.length) return storedBands;
  return OPERATION_BANDS.map((band) => ({
    band,
    value: operationTariffValueForLegacyBand(tariff, band),
  }));
}

export function normalizeOperationTariffBands(rawBands, templateBands = []) {
  const source = Array.isArray(rawBands) ? rawBands : [];
  const template = Array.isArray(templateBands) ? templateBands : [];
  if (template.length) {
    return template.map((templateBand) => {
      const stored = source.find((item) => String(item?.band || '') === templateBand.band);
      return {
        ...templateBand,
        from: Number(stored?.from ?? templateBand.from ?? 0),
        to: Number(stored?.to ?? templateBand.to ?? 0),
        value: Number(stored?.value ?? templateBand.value ?? 0),
      };
    });
  }
  return source
    .filter((item) => String(item?.band || '').trim())
    .map((item) => ({
      band: String(item.band).trim(),
      from: Number(item.from ?? 0),
      to: Number(item.to ?? 0),
      value: Number(item.value ?? 0),
    }));
}

function operationTariffValueForLegacyBand(tariff, band) {
  if (!tariff) return 0;
  const keys = {
    'Hasta 4 horas': ['valor_hasta_4', 'hasta_4hs'],
    '4 a 8 horas': ['valor_4_a_8', 'de_4_a_8hs'],
    '8 a 12 horas': ['valor_8_a_12', 'de_8_a_12hs'],
  }[band] || [];
  const value = keys.map((key) => tariff[key]).find((item) => item !== undefined && item !== null && item !== '');
  return Number(value || tariff.valor || 0);
}

export function operationTariffLabel(tariff) {
  if (!tariff) return '';
  const explicit = tariff.nombre || tariff.name;
  if (explicit) return explicit;
  return [tariff.categoria, tariff.tipo].filter(Boolean).join(' · ') || `Tarifa ${tariff.id}`;
}

export function personDisplayName(person) {
  return personSystemAlias(person);
}

export function personOperationalRole(person) {
  return person?.rol_operativo || person?.operational_role || person?.role || '';
}

export function isAdministrativeOperationalRole(personOrRole) {
  const role = typeof personOrRole === 'string' ? personOrRole : personOperationalRole(personOrRole);
  const normalized = normalizeSearchText(role);
  return normalized === 'administracion';
}

export function canSubmitOperations(person) {
  return person?.can_submit_operations === true;
}

export function isActivePerson(person) {
  if (person?.activo !== undefined) return Number(person.activo) !== 0;
  return person?.active !== false;
}
